import React from 'react'
import { withTranslation as translate } from 'react-i18next'

class bestPriceGuarantee extends React.Component{


  render(){
    const _t = this.props.t
    return(
      <div className="container best-price-guarantee">
        <h1>{_t('great_price_best_price_guarantee')}</h1>
        <img src={require('../images/misc/best_price_guarantee.png')} alt="best price icon"/>
        <p>
          {_t('great_price_we_give_you_a_best_price')}
        </p>
        <p>{_t('great_price_we_notify_us_at')} <a href="mailto:booking@handiscover.com">booking@handiscover.com</a></p>
        <p><b>{_t('great_price_guarantee_does')}</b></p>
        <p>
          {_t('great_price_promotional_rates')}
        </p>
        <p><b>{_t('great_price_following_conditions')}</b></p>
        <p>
          {_t('great_price_reservation_must')}
        </p>
      </div>
    )    
  }
}
export default bestPriceGuarantee